
import { Component, Vue } from 'vue-property-decorator'
import ForceChangePassword from '@/components/templates/ForceChangePassword.vue'
import { ApiNotFoundAppError } from '@/models/AppErrorClasses'
import { ActivateTokensApi } from '@/api/methods/activate/ActivateTokensApi'
import { ActivateUsersApi } from '@/api/methods/activate/ActivateUsersApi'
import PasswordUtils from '@/utils/PasswordUtils'

/**
 * パスワード登録ページ
 */
@Component({
  components: {
    ForceChangePassword,
  },
})
export default class RegistPassword extends Vue {
  /**
   * クエリのトークン情報取得
   *
   * @returns クエリのトークン情報
   */
  private get token(): string {
    const token = this.$route.query.token
    if (!token || typeof token !== 'string') {
      // トークン未指定時、指定不正時は空文字列を返す
      return ''
    }
    return token
  }

  /**
   * 開始時の処理
   */
  private async mounted(): Promise<void> {
    this.$loading.start()
    try {
      await ActivateTokensApi.checkToken(this.token)
    } catch (error) {
      if (error instanceof ApiNotFoundAppError) {
        this.$loading.complete()
        await this.$router.push('/activate/invalid')
        return
      }

      // 404エラー以外の場合は例外を投げ直し、共通処理に渡す
      throw error
    }
    // 正常終了時は何もしない
    this.$loading.complete()
  }

  /**
   * パスワード更新処理
   *
   * @param password パスワード
   * @param confirmPassword パスワード(確認用)
   */
  private async eventUpdatePassword(password: string, confirmPassword: string): Promise<void> {
    this.$loading.start()

    if (password !== confirmPassword) {
      alert('新しいパスワードと確認用パスワードが一致しません。')
      this.$loading.complete()
      return
    }

    // パスワード指定が適切かのチェック
    const errorMessage = PasswordUtils.checkPasswordEnabled(password)
    if (errorMessage) {
      alert(errorMessage)
      this.$loading.complete()
      return
    }

    // パスワード登録・ユーザ有効化処理
    try {
      await ActivateUsersApi.createUser(this.token, password)
    } catch (error) {
      // トークン期限切れ時の遷移
      if (error instanceof ApiNotFoundAppError) {
        this.$loading.complete()
        await this.$router.push('/activate/invalid')
        return
      }

      // 404エラー以外の場合は例外を投げ直し、共通処理に渡す
      throw error
    }

    // 認証情報を削除し、完了画面に遷移
    this.$appCookies.removeAuth()

    this.$loading.complete()

    await this.$router.push('/activate/complete')
  }
}
